import { IntlShape } from "react-intl";
import { LocalStorageKey } from "../../data/constants";

export interface TranslatedValue {
  de: string;
  fr: string;
  it: string;
  en: string;
}

export const GetTranslatedValue = (translatedValue: TranslatedValue) => {
  const language = localStorage.getItem(LocalStorageKey.LastSelectedLanguageKey)?.toLowerCase();
  return !!language && language in translatedValue
    ? translatedValue[language as keyof TranslatedValue]
    : translatedValue.de;
};

export const GetTranslatedValueIntl = (intl: IntlShape, translatedValue: TranslatedValue) => {
  return intl.locale.toLowerCase() in translatedValue
    ? translatedValue[intl.locale.toLowerCase() as keyof TranslatedValue]
    : translatedValue.de;
}
